import React from 'react';
import CrosswalksChart from '../CrosswalksChart';

class Crosswalks extends React.Component {
  render() {
    return (
      <div>
        <p>
          Every day I save about 3 minutes by changing the series of
          crosswalks I take on my way to work and back. The time I spend walking is
          always the same, but by opportunistically choosing where and when
          to cross based on the lights, I save time waiting on lights to
          change.
        </p>
        <p>
          Here's the chart of the expected wait time necessary to reach a
          destination in the northwest corner,
          starting from various points on the grid. I'm assuming a crosswalk
          alternation time of 45 seconds and that it takes 10 seconds to walk
          across one. Hover over points for
          more details.
        </p>
        <p>
          Each square represents a city block, and each dot is one of its
          corners. The redness at that dot is proportional to the wait time
          to reach the destination from it.
        </p>
        <CrosswalksChart
          vertexStyle="wait"
          id="wait"
        />
        <p>
          If you were to go 10 blocks north, then 10 blocks west, your expected
          wait would be 302.6 seconds, but if you follow the ideal walking
          strategy starting from the same point, your wait is only 49.8
          seconds! That's 84% wait time savings!
        </p>
        <p>
          At the corner of each city block, you have up to three options:
        </p>
        <ul>
          <li>Go north</li>
          <li>Go west</li>
          <li>
            Go "diagonally"; if you are at the northwest corner, cross north
            and then west or west and then north. Let's zoom in closer on
            how likely each of those options is to be best, based on the time
            at which you enter the light cycle.
          </li>
        </ul>
        <p>
          Your decision between these three options is determined by the
          (random) time
          into the light cycle at which you reach the intersection. This next
          chart shows your chance to make each decision, depending on your
          location, indicated by the thickness of each edge.
        </p>
        <CrosswalksChart
          vertexStyle="wait"
          edgeStyle="chance"
          id="edge"
        />
        <p>
          Again, suppose you start 10 blocks south and 10 blocks east. Let's take
          a look at how likely you are to pass through each intermediate block
          corner on your way to your destination. Here the size of each dot is
          proportional to your chance to reach it along the way.
        </p>
        <CrosswalksChart
          vertexStyle="chance"
          id="chance"
        />
      </div>
    );
  }
}

export default Crosswalks;



// WEBPACK FOOTER //
// src/components/Crosswalks/Crosswalks.js